<template>
  <b-link
    :class="{ onlyIcon: onlyIcon }"
    class="btn-social"
    id="googleSignIn"
    @click="action"
  >
    <b-img
      :class="{ onlyIcon: onlyIcon, 'btn-social-margin': !onlyIcon }"
      :src="getImage"
      :alt="$t('continueWithGoogle')"
    ></b-img>
    <template v-if="!onlyIcon">
      {{ $t("continueWithGoogle") }}
    </template>
  </b-link>
</template>

<script>
export default {
  name: "UiGoogle",
  props: {
    action: {
      type: Function,
      default: null
    },
    onlyIcon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImage() {
      return !this.onlyIcon
        ? `${this.publicPath}assets/images/icons/icon-google.svg`
        : `${this.publicPath}assets/images/google.png`;
    }
  }
};
</script>
